export default __webpack_public_path__ + "static/macbook.df7f8fd7b030960d5538844d46c5f6ed.png";